(function () {
  'use strict';

  angular.module('app').component('providerCreditNoteList', providerCreditNoteList());

  function providerCreditNoteList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        onShowItem: '&',
      },
      controller: ProviderCreditNoteListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/provider-credit-notes/provider-credit-note-list/provider-credit-note-list.component.html',
    };
  }

  ProviderCreditNoteListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'SessionService',
    'moment',
    'ProviderCreditNoteService',
  ];

  function ProviderCreditNoteListComponent(
    config,
    UtilService,
    AbilityService,
    SessionService,
    moment,
    ProviderCreditNoteService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_providercreditnote_accountadmin'),
      canUpdate: AbilityService.can('update_providercreditnote_accountadmin'),
      canDestroy: AbilityService.can('destroy_providercreditnote_accountadmin'),
    };

    vm.creditNoteStatuses = angular.copy(config.CREDIT_NOTES_STATUSES);
    vm.creditNoteStatuses.unshift({
      label: 'ALL',
      value: null,
    });

    vm.statusProcessed = 'processed';

    // private properties
    // -----------------------
    const company = SessionService.getSelectedAccountCompany();

    let userLanguageCode = SessionService.getUserLanguage().code;
    let dateDisplay = userLanguageCode !== 'es' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';

    // const dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.$onInit = function () {
      vm.atvCrEnabled = company.atv_cr_enabled;

      setProviderCreditNotes(vm.items);

      setDefaultFilters();

      setDocumentDatePicker();
    };

    // public methods
    // -----------------------
    vm.fetchResult = function () {
      vm.loadingItems = true;
      ProviderCreditNoteService.getProviderCreditNotes(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        setProviderCreditNotes(vm.items);

        vm.totalItems = vm.meta.totalItems;
        vm.loadingItems = false;
      });
    };

    vm.refresh = function () {
      vm.fetchResult();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      vm.fetchResult();
    };

    vm.showItem = function (item, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowItem({ item: item, mode: mode });
    };

    vm.deleteItem = function (item) {
      if (!vm.permissions.canDestroy) return;

      ProviderCreditNoteService.deleteProviderCreditNote(item, vm.fetchResult());
    };

    vm.clearDocumentDate = function () {
      vm.documentDatePicker = {
        startDate: '',
        endDate: '',
      };

      delete vm.filterCriteria.by_date_from;
      delete vm.filterCriteria.by_date_to;

      vm.UtilService.filterResult();
    };

    vm.clearSearch = function () {
      setDefaultFilters();
      vm.fetchResult();
    };

    vm.downloadProviderCreditNotePdf = function (item) {
      ProviderCreditNoteService.downloadProviderCreditNotePDF(item, userLanguageCode);
    };

    // private methods
    // -----------------------
    function setProviderCreditNotes(items) {
      // items.map((item) => {
      items.forEach((item) => {
        item.date = moment(item.date).format(dateDisplay);
        item.provider_credit_note_number = item.provider_credit_note_number || '-';
        item.provider_name = item.provider.name + ' ' + item.provider.last_name;
      });
    }

    function setDefaultFilters() {
      vm.documentDatePicker = {
        // startDate: '',
        // endDate: '',
        startDate: vm.UtilService.startOfMonth(),
        endDate: vm.UtilService.today(),
      };

      vm.filterCriteria = ProviderCreditNoteService.getFilterCriteria();

      vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
        vm.UtilService.startOfMonth()
      );

      vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());

      // vm.filterCriteria.by_status = vm.creditNoteStatuses[0].value;
    }

    function setDocumentDatePicker() {
      let filterByDocumentDate = () => {
        vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
          vm.documentDatePicker.startDate
        );

        vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.documentDatePicker.endDate);

        vm.UtilService.filterResult();
      };

      vm.documentDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByDocumentDate,
        rangeOptions: config.DOCUMENT_DATE_OPTIONS,
        dateDisplay: dateDisplay,
        maxDate: moment(),
      });
    }
  }
})();
